import React from "react";
import { FormattedMessage } from "react-intl";

export default class ErrorBoundary extends React.Component {

    constructor(props) {
      super(props);
      this.state = { hasError: false, text: '', error: '', info: '' };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, text: error.toString() };
    }
  
    componentDidCatch(error, info) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      this.setState( { error: error.toString(), info: info.componentStack } );
      console.log(error, info.componentStack);
    }
  
    render() {
      if (this.state.hasError) {
        return (
        <>
          <h2><FormattedMessage id='error.boundary.header'/></h2>
          <div><FormattedMessage id='error.boundary.info'/></div>
           <br/>
          <pre>{this.state.text} <br/>
          {this.state.info}</pre>
          <button className="btn btn-primary" onClick={() => { window.location.reload() }}>
            <FormattedMessage id='button.error.reload'/>
          </button>
        </>);
      }
  
      return this.props.children;
    }
  }